import { useState, useEffect, useCallback } from "react";
import debounce from "lodash/debounce";
import { useDebouncedSearchProviders } from "./queries";

const useSearch = (isFilterSearch, onSearch, resetFilters) => {
  const [searchText, setUpdatedSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const [showResults, setShowResults] = useState(false);

  const debounceSearch = useCallback(
    debounce((text) => {
      setDebouncedSearchText(text);
    }, 300),
    []
  );

  const handleSearchTextChange = (e) => {
    const text = e.target.value;
    setUpdatedSearchText(text);

    if (text.length >= 1) {
      debounceSearch(text);
      setShowResults(true);
    } else {
      setShowResults(false);
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    if (isFilterSearch) {
      try {
        await onSearch(searchText);
      } catch (error) {
        console.error("Error during search:", error);
      }
    }
  };

  const handleResultClick = (provider) => {
    setUpdatedSearchText("");
    setShowResults(false);
  };

  // const handleClearSearch = () => {
  //   setUpdatedSearchText('');
  //   setShowResults(false);
  //   resetFilters();
  // };

  useEffect(() => {
    if (searchText && searchText.length < 1) {
      setDebouncedSearchText("");
      setShowResults(false);
    }
  }, [searchText]);

  const {
    data: results,
    isLoading,
    isError,
  } = useDebouncedSearchProviders(debouncedSearchText);

  return {
    searchText,
    setUpdatedSearchText,
    showResults,
    results,
    isLoading,
    isError,
    handleSearchTextChange,
    handleSearch,
    handleResultClick,
    // handleClearSearch
  };
};

export default useSearch;
